import { render, staticRenderFns } from "./changeHighSetting.vue?vue&type=template&id=eda658c6&scoped=true&"
import script from "./changeHighSetting.vue?vue&type=script&lang=js&"
export * from "./changeHighSetting.vue?vue&type=script&lang=js&"
import style0 from "./changeHighSetting.vue?vue&type=style&index=0&id=eda658c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda658c6",
  null
  
)

export default component.exports